import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button } from "@bookips/sds";
import { useState } from "react";
import BillingPlanCard from "./BillingPlanCard";
import HomeSectionLayout from "./HomeSectionLayout";
/** API 아이템을 컴포넌트 데이터로 변환 */ const transformItem = (item)=>({
        type: item.type,
        thumbnailUrl: item.thumbnail,
        tagText: item.tag,
        title: item.itemTitle,
        keyText: item.keyText,
        bodyText: item.bodyText,
        linkTexts: item.linkText,
        price: item.price,
        pricePeriod: item.pricePeriod ? item.pricePeriod === "yearly" ? "년" : "월" : null,
        originalPrice: item.originalPrice,
        discountRate: item.discountRate,
        isUseDiscountRate: item.useDiscountRate,
        buttonLabel: item.buttonLabel,
        buttonUrl: item.buttonLink
    });
const BillingPlanSection = (param)=>{
    let { sectionTitle , header , categories , content , buttonText , buttonUrl , entityId , homeId  } = param;
    const [activeCategory, setActiveCategory] = useState(categories[0]);
    const { isMobile  } = useWindowDimensions();
    // 선택된 카테고리에 해당하는 콘텐츠 찾기
    const activeContent = content.find((c)=>c.category === activeCategory);
    // 메인 상품과 서브 상품 분리
    const mainPlan = activeContent === null || activeContent === void 0 ? void 0 : activeContent.items.find((item)=>item.type === "main");
    var _activeContent_items_filter;
    const subPlans = (_activeContent_items_filter = activeContent === null || activeContent === void 0 ? void 0 : activeContent.items.filter((item)=>item.type === "sub")) !== null && _activeContent_items_filter !== void 0 ? _activeContent_items_filter : [];
    return /*#__PURE__*/ _jsxs(HomeSectionLayout, {
        title: sectionTitle,
        header: header,
        isUseButton: !!buttonText,
        buttonText: buttonText,
        buttonUrl: buttonUrl,
        onCtaClick: ()=>{
            // MX-387: 전체보기 버튼 클릭 트래킹
            mixpanelEvent("[Home] Billing Plan Section Clicked", {
                "Entity Id": entityId,
                "Home Id": homeId,
                "Section Title": sectionTitle,
                Type: "전체보기 버튼",
                "Button Name": buttonText,
                "Button URL": buttonUrl
            });
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center gap-2 px-5 sm:px-8 lg:px-0",
                children: categories === null || categories === void 0 ? void 0 : categories.map((category)=>/*#__PURE__*/ _jsx(Button, {
                        size: isMobile ? "sm" : "md",
                        variant: "stroke",
                        color: "secondary",
                        className: cn("text-primary", activeCategory === category ? "bg-gray-700 text-white outline-none" : "text-primary bg-white hover:bg-gray-50"),
                        onClick: ()=>{
                            // MX-387: 빌링 플랜 탭 클릭 트래킹
                            mixpanelEvent("[Home] Billing Plan Section Clicked", {
                                "Entity Id": entityId,
                                "Home Id": homeId,
                                "Section Title": sectionTitle,
                                Type: "빌링 플랜 탭",
                                "Button Name": category
                            });
                            setActiveCategory(category);
                        },
                        "data-state": activeCategory === category ? "active" : "inactive",
                        children: category
                    }, category))
            }),
            activeContent && /*#__PURE__*/ _jsxs("div", {
                className: cn(// 기본(md 미만): 가로 스크롤
                "scrollbar-hide flex gap-5 overflow-x-auto max-sm:px-5 sm:px-8", // md(1080px) 이상: 12열 CSS Grid (3과 4의 최소공배수)
                // 첫 행: 메인(6칸) + 서브(3칸) + 서브(3칸)
                // 둘째 행: 서브(3칸) × 4
                "md:grid md:grid-cols-12 md:overflow-visible lg:px-0"),
                children: [
                    mainPlan && /*#__PURE__*/ _jsx("div", {
                        className: "md:col-span-6",
                        children: /*#__PURE__*/ _jsx(BillingPlanCard, {
                            ...transformItem(mainPlan),
                            onButtonClick: ()=>{
                                // MX-388: 아이템 버튼 클릭 트래킹
                                mixpanelEvent("[Home] Billing Plan Section Clicked", {
                                    "Entity Id": entityId,
                                    "Home Id": homeId,
                                    "Section Title": sectionTitle,
                                    "Selected Tab": activeCategory,
                                    Type: "아이템 버튼",
                                    "Item Title": mainPlan.itemTitle,
                                    "Item Id": mainPlan.itemOrder,
                                    "Button Name": mainPlan.buttonLabel,
                                    "Button URL": mainPlan.buttonLink
                                });
                            }
                        })
                    }),
                    subPlans.map((item, idx)=>/*#__PURE__*/ _jsx("div", {
                            className: "md:col-span-3",
                            children: /*#__PURE__*/ _jsx(BillingPlanCard, {
                                ...transformItem(item),
                                onButtonClick: ()=>{
                                    // MX-388: 아이템 버튼 클릭 트래킹
                                    mixpanelEvent("[Home] Billing Plan Section Clicked", {
                                        "Entity Id": entityId,
                                        "Home Id": homeId,
                                        "Section Title": sectionTitle,
                                        "Selected Tab": activeCategory,
                                        Type: "아이템 버튼",
                                        "Item Title": item.itemTitle,
                                        "Item Id": item.itemOrder,
                                        "Button Name": item.buttonLabel,
                                        "Button URL": item.buttonLink
                                    });
                                }
                            })
                        }, idx))
                ]
            })
        ]
    });
};
export default BillingPlanSection;
